import columns from '../../../../react-table/helpers/columns';

export default (data) => {
  const {
    NumberColumn,
  } = columns(data);

  return [
    {
      Header: 'Expected',
      columns: [
        new NumberColumn('Current day', 'currentDay'),
        new NumberColumn('Tomorrow', 'tomorrow'),
        new NumberColumn('next 7 days', 'nextSevenDays'),
        new NumberColumn('Total', 'total'),
        new NumberColumn('on Hold', 'onHold'),
      ],
    },
  ];
};
